import {
  type IDropOptions,
  type IInboxTreeCombine,
  type INodeModel,
  TreeRootInboxes,
} from 'entities/Inbox'
import { type ConversationMenuStore } from 'pages/conversations/ui/ConversationMenu'

export const actionReorderFavoritesDragDrop = async (
  items: INodeModel<IInboxTreeCombine>[],
  options: IDropOptions<IInboxTreeCombine>,
  dropRoot: TreeRootInboxes,
  store: ConversationMenuStore
) => {
  const isReorderInsideFavorites =
    dropRoot === TreeRootInboxes.FAVORITE &&
    options.dragSource?.parent === TreeRootInboxes.FAVORITE &&
    options.dropTargetId === TreeRootInboxes.FAVORITE

  if (!isReorderInsideFavorites) return

  const orderedTopLevel = items.filter((node) => node.parent === TreeRootInboxes.FAVORITE)

  await store.favoritesMenuStore.reorderFavorites(orderedTopLevel)
}
